import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  input,
  InputSignal,
  Type,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewContentComponent } from './content/preview-content.component';
import { DarkModeToggleComponent } from '../dark-mode-toggle/dark-mode-toggle.component';

@Component({
  selector: 'aw-preview',
  imports: [CommonModule, PreviewContentComponent, DarkModeToggleComponent],
  templateUrl: './preview.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewComponent {
  public components: InputSignal<Type<any>[]> = input.required();
  public previewData: InputSignal<any[]> = input.required();

  @ViewChild('draggableBox') boxRef!: ElementRef<HTMLDivElement>;

  public isOpen: boolean = false;
  public isMax: boolean = false;
  public isMobile: boolean = false;
  public maxViewOffset: string = '';

  private isDragging: boolean = false;
  private offsetX: number = 0;
  private offsetY: number = 0;

  startDrag(event: MouseEvent) {
    const box = this.boxRef.nativeElement;
    const rect = box.getBoundingClientRect();

    this.isDragging = true;
    this.offsetX = event.clientX - rect.left;
    this.offsetY = event.clientY - rect.top;

    // Switch from bottom/right to top/left so we can move it freely
    box.style.bottom = 'auto';
    box.style.right = 'auto';
    box.style.top = rect.top + 'px';
    box.style.left = rect.left + 'px';
    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;

    const box = this.boxRef.nativeElement;
    const parent = document.documentElement; // or any fixed parent container
    const boxRect = box.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    // Calculate desired position
    let newLeft = event.clientX - this.offsetX;
    let newTop = event.clientY - this.offsetY;

    // Clamp to boundaries
    newLeft = Math.max(
      parentRect.left,
      Math.min(newLeft, parentRect.right - boxRect.width)
    );
    newTop = Math.max(
      parentRect.top,
      Math.min(newTop, parentRect.bottom - boxRect.height)
    );

    box.style.left = `${newLeft}px`;
    box.style.top = `${newTop}px`;
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }

  openPreview() {
    this.isOpen = true;
  }

  maxPreview() {
    this.setMaxViewOffset();
    this.isMax = true;
  }

  closePreview() {
    this.isOpen = false;
    this.isMax = false;
  }

  minPreview() {
    this.isMax = false;
  }

  toggleScreenSize() {
    this.isMobile = !this.isMobile;
  }

  private setMaxViewOffset(): void {
    const sideBar: HTMLElement | null =
      document.getElementsByTagName('aside')?.[0];
    if (sideBar) {
      this.maxViewOffset = sideBar.getBoundingClientRect().width + 'px';
    }
  }
}
